var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24SelectedGuildeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2C8.086 2 7.75 2.3355 7.75 2.75V3.5H6.25C5.0095 3.5 4 4.5095 4 5.75V19.25C4 20.4905 5.0095 21.5 6.25 21.5H17.75C18.9905 21.5 20 20.4905 20 19.25V5.75C20 4.5095 18.9905 3.5 17.75 3.5H17.25V5.25C17.25 5.526 17.0265 5.75 16.75 5.75C16.4735 5.75 16.25 5.526 16.25 5.25V3.5V2.75C16.25 2.3355 15.914 2 15.5 2C15.086 2 14.75 2.3355 14.75 2.75V3.5H13.75V5.25C13.75 5.526 13.5265 5.75 13.25 5.75C12.9735 5.75 12.75 5.526 12.75 5.25V3.5V2.75C12.75 2.3355 12.414 2 12 2C11.586 2 11.25 2.3355 11.25 2.75V3.5H10.25V5.25C10.25 5.526 10.0265 5.75 9.75 5.75C9.4735 5.75 9.25 5.526 9.25 5.25V3.5V2.75C9.25 2.3355 8.914 2 8.5 2ZM8.25 8.5H15.75C16.164 8.5 16.5 8.8355 16.5 9.25C16.5 9.6645 16.164 10 15.75 10H8.25C7.836 10 7.5 9.6645 7.5 9.25C7.5 8.8355 7.836 8.5 8.25 8.5ZM8.25 12.5H11.75C12.164 12.5 12.5 12.8355 12.5 13.25C12.5 13.6645 12.164 14 11.75 14H8.25C7.836 14 7.5 13.6645 7.5 13.25C7.5 12.8355 7.836 12.5 8.25 12.5ZM8.25 16.5H13.75C14.164 16.5 14.5 16.8355 14.5 17.25C14.5 17.6645 14.164 18 13.75 18H8.25C7.836 18 7.5 17.6645 7.5 17.25C7.5 16.8355 7.836 16.5 8.25 16.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24SelectedGuildeline);
export default __webpack_public_path__ + "static/media/icn_24x24_selected_guildeline.5f69107afd42bf3c37ca8859cc78a0aa.svg";
export { ForwardRef as ReactComponent };